import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3d4c257c"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4c257c')) {
      api.createRecord('3d4c257c', component.options)
    } else {
      api.reload('3d4c257c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=3d4c257c", function () {
      api.rerender('3d4c257c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/inventario/edit.vue"
export default component.exports